const { Container, Grid, useTheme } = require('@mui/material')

export const GridLarge = ({ children, ...otherProps }) => {
  return (
    <Grid
      paddingX={{ xs: 6, sm: 16, md: 20, lg: 32 }}
      paddingY={{ xs: 6, sm: 16, md: 20, lg: 24 }}
      gap={{ xs: 6, sm: 16, md: 20, lg: 24 }}
      {...otherProps}>
      {children}
    </Grid>
  )
}

export const GridMedium = ({ children, ...otherProps }) => {
  return (
    <Grid
      padding={{ xs: 6, sm: 12, md: 16 }}
      gap={{ xs: 6, sm: 12, md: 16 }}
      {...otherProps}>
      {children}
    </Grid>
  )
}

export const FloatingGrid = ({ children, sx, ...otherProps }) => {
  const theme = useTheme()
  return (
    <GridMedium
      sx={{
        borderRadius: 3,
        backgroundColor: theme.palette.background.paper,
        boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.15)',
        ...sx
      }}
      {...otherProps}>
      {children}
    </GridMedium>
  )
}

export const ContainerLarge = ({ children, ...otherProps }) => {
  return (
    <Container
      maxWidth='xl'
      sx={{
        paddingX: { xs: 6, sm: 8, md: 16, lg: 24 },
        paddingY: { xs: 12, sm: 12, md: 12, lg: 12 }
      }}
      {...otherProps}>
      {children}
    </Container>
  )
}

export const ParentGridContainer = ({ children, ...otherProps }) => {
  return (
    <Grid
      container
      width='100%'
      margin={'0 auto'}
      paddingTop={20}
      spacing={6}
      {...otherProps}>
      {children}
    </Grid>
  )
}
